const purchaserAnalysisRoutes = [
  {
    path: '/purchaser-analysis',
    redirect: '/purchaser-analysis/list',
    children: [
      {
        path: '/list',
        name: 'PurchaserAnalysisList',
        component: () => import('@/views/purchaser-analysis/list'),
        meta: {
          layout: 'DefaultLayout',
          title: '采购单位分析',
          inNavbar: true,
          cache: true,
          pageType: 'public',
          routeGroup: '大数据服务'
        }
      },
      {
        path: '/:companyId/detail',
        name: 'PurchaserAnalysisDetail',
        component: () => import('@/views/purchaser-analysis/detail'),
        meta: {
          layout: 'DefaultLayout',
          title: '采购单位分析报告',
          inNavbar: false,
          pageType: 'public'
        }
      }
    ]
  }
]

export default purchaserAnalysisRoutes
